export default __webpack_public_path__ + "img/bfdefb11def3565783b9b35e3714743f.png";